import type { AppPaneName, HeaderPaneName } from 'owa-app-pane-group-types';
import { onOpenAppPane, onOpenHeaderPane } from 'owa-app-pane-group-actions';
import { isCapabilityEnabled } from 'owa-capabilities';
import { newHeaderCapability } from 'owa-capabilities-definitions/lib/newHeaderCapability';
import { openFlexPane } from 'owa-suite-header-apis/lib/flexpanes/utils/openFlexPane';
import isAppPane from '../utils/isAppPane';
import isHeaderPane from '../utils/isHeaderPane';

export default function openFlexPaneHelper(
    suitePaneName: string,
    paneName?: AppPaneName | HeaderPaneName,
    targetWindow?: Window
): void {
    if (!paneName || !isCapabilityEnabled(newHeaderCapability)) {
        openFlexPane(suitePaneName);
        return;
    }

    if (isAppPane(paneName)) {
        onOpenAppPane(paneName, targetWindow);
    } else if (isHeaderPane(paneName)) {
        onOpenHeaderPane(paneName, targetWindow);
    } else {
        openFlexPane(suitePaneName);
    }
}
